module.exports = __webpack_public_path__ + "img/grey-top.b08e6cf6.png";